import { render } from "./linkHealthRecordView.vue?vue&type=template&id=23c47cdc&scoped=true"
import script from "./linkHealthRecordView.vue?vue&type=script&lang=js"
export * from "./linkHealthRecordView.vue?vue&type=script&lang=js"

import "./linkHealthRecordView.vue?vue&type=style&index=0&id=23c47cdc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c47cdc"]])

export default __exports__